import promiseFinally from 'promise.prototype.finally';

const shim = () => {
  promiseFinally.shim();
};
export default shim;



// WEBPACK FOOTER //
// ./src/initialize/shim/index.js